<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="type" slot-scope="data">
          <span v-if="data.row.type*1 === 1">投递可回收物</span>
          <span v-if="data.row.type*1 === 2">后台充值</span>
          <span v-if="data.row.type*1 === 3">取消订单返还</span>
          <span v-if="data.row.type*1 === 4">异常订单返还</span>
          <span v-if="data.row.type*1 === 5">每日任务</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_ORDER',
        formComponent: {
          view: { type: 'component', componentName: 'integralAbnormalReportView', value: 'queryOrderDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/userIntegralDetails/userIntegralRedLineList' }
        },
        formInputsData: [{ name: '搜索昵称', key: 'keyWord', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] },
          { name: '获取方式',
            key: 'type',
            value: '',
            type: 'select',
            data: [{ label: '全部', value: '' },
              { label: '投递可回收物', value: 1 },
              { label: '后台充值', value: 2 },
              { label: '取消订单返还', value: 3 },
              { label: '异常订单返还', value: 4 },
              { label: '每日任务', value: 5 }] }],
        formButtonsData: [],
        formTableData: [
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '获取积分', key: 'integral', type: 'text' },
          { name: '获取方式', key: 'type', type: 'custom' },
          { name: '获取时间', key: 'createTime', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [{ name: '查看详情', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setintegralAbnormalReportDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.form.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
